import * as Sentry from '@sentry/browser';
import get from 'lodash/get';

/**
 * Logs to Sentry.io
 *
 * @param response
 * @param details
 * @param details.contextId
 * @param details.payload
 * @param details.userName
 * @param flag
 * @constructor
 */
const Logger = (response, details, flag) => {
  const message = get(
    response,
    'data.ResponseStatus.Message',
    'An error has occurred.'
  );
  const code = get(response, 'data.ResponseStatus.Code', '');
  if (flag) {
    Sentry.withScope((scope) => {
      scope.setExtra('Error Message', message);
      scope.setExtra('Error Code', code);
      scope.setExtra('Payload', details.payload);
      scope.setExtra('Context ID', details.contextId);
      scope.setUser({ id: details.contextId, username: details.userName });
      Sentry.captureException(new Error(message));
    });
  }
};

export default Logger;



// WEBPACK FOOTER //
// ./src/common/lib/Logger.js